interface IconProps {
  size?: number;
}

export function HospitalBuildingPinIcon({ size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      aria-hidden={true}
    >
      <path
        d={'M1.05478 3.61542H7.90312V14.8512H1.05478L1.05478 3.61542Z'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M7.90314 9.91071H12.9196V14.851H7.90314V9.91071Z'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M3.55801 8.53712V5.77405M5.40006 5.77405V8.53712M3.55801 7.04044H5.40006'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M14.9452 3.44638C14.9452 4.71764 12.6477 7.78603 12.6477 7.78603C12.6477 7.78603 10.3503 4.71764 10.3503 3.44638C10.3503 2.83706 10.5924 2.25269 11.0232 1.82183C11.4541 1.39098 12.0384 1.14893 12.6477 1.14893C13.2571 1.14893 13.8414 1.39098 14.2723 1.82183C14.7032 2.25269 14.9452 2.83706 14.9452 3.44638Z'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M12.6478 3.73975C12.4978 3.73975 12.3761 3.61808 12.3761 3.46799C12.3761 3.3179 12.4978 3.19623 12.6478 3.19623'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M12.6477 3.73975C12.7978 3.73975 12.9195 3.61808 12.9195 3.46799C12.9195 3.3179 12.7978 3.19623 12.6477 3.19623'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M4.47919 14.851V12.9098'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  );
}

export function LightBulbShineIcon({ size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      aria-hidden={true}
    >
      <g>
        <path
          d={'M7.0625 14.5625H8.9375'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={
            'M11.75 7.99999C11.7525 7.29805 11.5579 6.6095 11.1884 6.01266C10.819 5.41583 10.2894 4.93469 9.65995 4.62397C9.03052 4.31326 8.32651 4.18544 7.62803 4.25507C6.92955 4.3247 6.26463 4.58897 5.70892 5.01783C5.15321 5.44669 4.72903 6.0229 4.48464 6.68093C4.24024 7.33895 4.18544 8.05237 4.32647 8.74C4.4675 9.42763 4.79869 10.0619 5.28238 10.5706C5.76607 11.0793 6.38282 11.442 7.06248 11.6175V12.6875H8.93748V11.6175C9.74096 11.4116 10.4532 10.9445 10.9623 10.2897C11.4714 9.63487 11.7485 8.82943 11.75 7.99999Z'
          }
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M8 2.375V1.4375'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M13.625 7.0625H14.5625'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M1.4375 8H2.375'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M11.9775 11.5087L12.6406 12.1719'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M3.35938 2.89062L4.0225 3.55375'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M11.9775 3.55375L12.6406 2.89062'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
        <path
          d={'M3.35938 12.1719L4.0225 11.5087'}
          stroke={'currentColor'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
        />
      </g>
    </svg>
  );
}
